import { render, staticRenderFns } from "./menutable.vue?vue&type=template&id=75afa1cc&scoped=true&"
import script from "./menutable.vue?vue&type=script&lang=js&"
export * from "./menutable.vue?vue&type=script&lang=js&"
import style0 from "./menutable.vue?vue&type=style&index=0&id=75afa1cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75afa1cc",
  null
  
)

export default component.exports